import { Datepicker } from "flowbite-react";
import { useState } from "react";
import SelectInput from "../externalComponents/tailwind/select-input";
import {
  generateDateTimeArray,
  getNextTimeSlot,
  updateDateTime,
} from "../functions/date-utils";

export const DateTimePicker = ({ dateTimeChanged, dataNode }) => {
  const now = new Date();
  const minDate = new Date(now.getFullYear(), now.getMonth(), now.getDate());
  const maxDate = new Date(
    now.getFullYear(),
    now.getMonth(),
    now.getDate() + 30,
  );

  const expirationDate = dataNode?.expirationDate
    ? new Date(dataNode.expirationDate)
    : null;

  // Initialiser la date avec expirationDate ou minDate
  const [selectedDates, setSelectedDates] = useState(
    expirationDate && !isNaN(expirationDate) ? expirationDate : minDate,
  );

  const options = generateDateTimeArray();
  const [selected, setSelected] = useState(() => {
    if (expirationDate && !isNaN(expirationDate)) {
      const formattedTime = `${expirationDate.getHours().toString().padStart(2, "0")}h${expirationDate.getMinutes().toString().padStart(2, "0")}`;
      return (
        options.find((option) => option === formattedTime) ||
        getNextTimeSlot(options)
      );
    }
    return getNextTimeSlot(options);
  });

  const handleSelectChange = (value, _selectedDates) => {
    setSelected(value);
    const dataTime = updateDateTime(_selectedDates, value);
    dateTimeChanged(dataTime);
  };

  const handleSelectedDates = (start, _selected) => {
    setSelectedDates(start);
    const dataTime = updateDateTime(start, _selected);
    dateTimeChanged(dataTime);
  };

  const customTheme = {
    popup: {
      root: {
        inner:
          "inline-block rounded-customBorderRadius bg- p-4 border w-full mb-5 dark:bg-gray-800",
      },
    },
    views: {
      days: {
        items: {
          base: "grid w-full grid-cols-7",
          item: {
            base: "block flex-1 cursor-pointer rounded-lg border-0 text-center text-sm font-semibold leading-9 text-gray-900 hover:bg-gray-100 dark:text-white dark:hover:bg-gray-600",
            selected: "bg-yellow hover:bg-yellow",
            disabled: "text-gray-400",
          },
        },
      },
    },
  };

  return (
    <>
      <div className="mt-2">
        <SelectInput
          options={options}
          onChange={(e) => handleSelectChange(e, selectedDates)}
          value={selected}
          selected={selected}
        />
        <Datepicker
          theme={customTheme}
          inline
          minDate={minDate}
          maxDate={maxDate}
          value={selectedDates}
          onChange={(e) => handleSelectedDates(e, selected)}
          weekStart={1}
          showClearButton={false}
          showTodayButton={false}
        />
      </div>
    </>
  );
};
